import axios from "axios";
import { BASE_URL } from "../util/constants";

export const sendRequest = async (payload, method, url, headers) => {
  const options = {
    method,
    headers: {
      ...headers,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: payload ? new URLSearchParams({ ...payload }) : null,
    url: `${BASE_URL}/${url}`,
  };
  try {
    const { data, error } = await axios(options);

    if (data) return data;

    console.error("error while fetching data", error);
    return { status: false, message: error.message };
  } catch (err) {
    console.error("error while sending request", err);
    return { status: false, message: err.message };
  }
};
